import { render, staticRenderFns } from "./VaSidebarLinkGroup.vue?vue&type=template&id=163182da&"
import script from "./VaSidebarLinkGroup.vue?vue&type=script&lang=js&"
export * from "./VaSidebarLinkGroup.vue?vue&type=script&lang=js&"
import style0 from "./VaSidebarLinkGroup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports